import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronThinLeft = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M20 28C20.5522 28 21 27.5523 21 27C21 26.7119 20.8774 26.4529 20.6824 26.2704C20.68 26.268 9.47988 16 9.47988 16C9.47988 16 20.68 5.732 20.6824 5.72963C20.8774 5.54713 21 5.28825 21 5C21 4.44775 20.5523 4 20 4C19.7434 4 19.51 4.0975 19.333 4.2565C19.3303 4.25887 7.32425 15.2629 7.32425 15.2629C7.11775 15.4524 7 15.7197 7 16C7 16.2802 7.11762 16.5477 7.32425 16.7371C7.32425 16.7371 19.3302 27.7411 19.333 27.7435C19.5101 27.9025 19.7434 28 20 28V28Z" />
	</svg>
);

export default ChevronThinLeft;
